/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Přidejte soubor nebo přetáhněte soubory zde`
};

const da_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Tilføj en fil eller træk filer hertil`
};

const de_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Datei hinzufügen oder Dateien hierher ziehen`
};

const en_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Add a file or drag files here`
};

const es_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Añade un archivo o arrastra los archivos aquí`
};

const fr_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouter un fichier ou faites glisser les fichiers ici`
};

const hu_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Fájl hozzáadása vagy húzd ide a fájlokat`
};

const it_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi un file o trascina qui i file`
};

const nl_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Voeg een bestand toe of sleep bestanden hierheen`
};

const pl_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Dodaj plik lub przeciągnij tutaj pliki`
};

const pt_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Adicione um arquivo ou arraste os arquivos aqui`
};

const sv_add_file = /** @type {(inputs: {}) => string} */ () => {
	return `Lägg till en fil eller dra filer hit`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const add_file = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.add_file(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("add_file", locale)
	if (locale === "cs") return cs_add_file(inputs)
	if (locale === "da") return da_add_file(inputs)
	if (locale === "de") return de_add_file(inputs)
	if (locale === "en") return en_add_file(inputs)
	if (locale === "es") return es_add_file(inputs)
	if (locale === "fr") return fr_add_file(inputs)
	if (locale === "hu") return hu_add_file(inputs)
	if (locale === "it") return it_add_file(inputs)
	if (locale === "nl") return nl_add_file(inputs)
	if (locale === "pl") return pl_add_file(inputs)
	if (locale === "pt") return pt_add_file(inputs)
	return sv_add_file(inputs)
};